import type { Tenant } from "./Tenant";

export interface ImpersonationState {
    active: boolean;
    byUserId: string | null;
    byIsSuperAdmin: boolean;
    originalUserId: string | null;
    targetUserId: string | null;
}

export interface User {
    _id: string;
    name: string;
    email: string;
    role: string;
    tenantId?: string;
    tenant?: Tenant;
    impersonated?: boolean;
    impersonation?: ImpersonationState | null;
    todoAccessScopeEmails?: string[];
}

export enum UserRole {
    USER = 'User',
    ADMIN = 'Admin',
    SUPER_ADMIN = 'SuperAdmin'
}
